require('./color.css');
require('./root.css');
export const theme = {
  color: 'internal',
  root: 'internal'
};